import {
    Store, Building2, Camera, Video, UtensilsCrossed, Flower2, Armchair, Music,
    Sparkles, Leaf, Shirt, ClipboardList, Bus, HeartHandshake, ShieldCheck, Cake,
    Gift, Mail, Crown, Gem, Heart, Star, Palette, Mic2, Car, Scissors, Sun, Award, Baby,
} from 'lucide-react';

// Shared by the homepage category cards and the Services page category strip.
// Categories are free text typed by service providers at registration, so a
// fixed map can't cover them all — known names get a matching icon, anything
// else gets one picked from POOL by a hash of the name, so the same category
// always shows the same icon everywhere.
const KNOWN = {
    'wedding hall/venue': Building2,
    'mahal': Building2,
    'photography': Camera,
    'videography': Video,
    'photography & videography': Camera,
    'catering': UtensilsCrossed,
    'event decoration': Flower2,
    'wedding rentals': Armchair,
    'dj & entertainment': Music,
    'choreography': Sparkles,
    'bridal makeup & hair': Sparkles,
    'mehndi artist': Leaf,
    'bridal styling': Shirt,
    'wedding planner': ClipboardList,
    'travel & accommodation': Bus,
    'officiant/priest': HeartHandshake,
    'security & valet': ShieldCheck,
    'wedding cake': Cake,
    'favors & gifts': Gift,
    'stationery & cards': Mail,
    // function cards that have no category of their own
    'engagement': Heart,
    'baby shower': Baby,
    'other': Store,
};

const POOL = [Crown, Gem, Heart, Star, Palette, Mic2, Car, Scissors, Sun, Award, Flower2, Gift, Sparkles, Store];

export const getCategoryIcon = (category = '') => {
    const key = category.trim().toLowerCase();
    if (KNOWN[key]) return KNOWN[key];
    if (!key) return Store;
    let hash = 0;
    for (let i = 0; i < key.length; i++) hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
    return POOL[hash % POOL.length];
};
